import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiService } from "../../utils/api";
import { FaBook, FaUsers, FaFileAlt } from "react-icons/fa";

function Dashboard() {
  const [documents, setDocuments] = useState([]);
  const [batches, setBatches] = useState([]);
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [teacherName, setTeacherName] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        let response = await apiService.getDashboardDataForTeacher();

        if (response && response.data && response.data.success) {
          const { documents, batches, students, teacher } = response.data.data;

          setDocuments(documents || []);
          setBatches(batches || []);
          setStudents(students || []);

          // Set teacher name in state
          if (teacher && teacher.username) {
            setTeacherName(teacher.username);
          }
        } else {
          console.error("API response unsuccessful:", response);
          setError("Failed to load dashboard data");
        }
      } catch (err) {
        console.error("Dashboard data fetch error:", err);
        setError("Error fetching data: " + (err.response?.data?.message || err.message || "Unknown error"));
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Add this to check if the component is rendering properly
  console.log("Current state:", { documents, batches, students, loading, error, teacherName });

  const handleViewDocument = (id) => {
    navigate(`/dashboard/teacher/documents/${id}`);
  };

  return (
      <div className="dashboard-section">
        <h2 className="welcome-heading">Welcome, {teacherName || "Teacher"}!</h2>

        <div className="teacher-stats-cards">
          <div className="teacher-stat-card">
            <div className="stat-icon document-icon">
              <FaFileAlt />
            </div>
            <div className="stat-info">
              <h3>{documents.length}</h3>
              <p>Documents</p>
            </div>
          </div>
          <div className="teacher-stat-card">
            <div className="stat-icon batch-icon">
              <FaBook />
            </div>
            <div className="stat-info">
              <h3>{batches.length}</h3>
              <p>Batches</p>
            </div>
          </div>
          <div className="teacher-stat-card">
            <div className="stat-icon student-icon">
              <FaUsers />
            </div>
            <div className="stat-info">
              <h3>{students.length}</h3>
              <p>Students</p>
            </div>
          </div>
        </div>

        <div className="recent-documents">
          <h3>Recent Documents</h3>
          {loading ? (
            <div className="loading-spinner"></div>
          ) : error ? (
            <p className="error-message">{error}</p>
          ) : documents.length === 0 ? (
            <p className="empty-message">No documents found. Start by scanning a document.</p>
          ) : (
            <div className="documents-grid">
              {documents.slice(0, 4).map((doc) => (
                <div key={doc.id} className="document-card" onClick={() => handleViewDocument(doc.id)}>
                  <div className="document-icon">
                    <FaFileAlt />
                  </div>
                  <div className="document-info">
                    <h4>{doc.title}</h4>
                    <p>Batch: {doc?.Batch?.name}</p>
                    <p>Created: {new Date(doc.createdAt).toLocaleDateString()}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
  );
}

export default Dashboard;
